/**
 * Download Service - validates tokens and returns all customer invoices (partner portal)
 */

const ATTACHMENT_SERVICE_URL = process.env.REACT_APP_ATTACHMENT_SERVICE_URL || 'https://invoice-attachment-service-789959682965.europe-west1.run.app';

export interface InvoiceAttachment {
  id: string;
  invoiceNumber: string;
  issueDate: any;
  dueDate: any;
  items: any[];
  attachmentCode: string;
  attachmentUrl: string;
  attachmentExcelUrl: string;
  attachmentStatusPdf?: string;
  attachmentStatusExcel?: string;
  pdfBase64: string;
  createdAt: any;
  grossAmount: number;
  buyerAddress?: string;
}

export interface DownloadValidationResult {
  success: boolean;
  customerName: string;
  invoices: InvoiceAttachment[];
  invoiceCount: number;
}

/**
 * Validate a download token and get all customer invoices
 */
export const validateDownloadToken = async (token: string): Promise<DownloadValidationResult | null> => {
  try {
    const response = await fetch(`${ATTACHMENT_SERVICE_URL}/download/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Invalid or expired token');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error validating download token:', error);
    return null;
  }
};
